@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.performanceIndicator {
  width: 100%;
}

.container {
  --indicator-count: 0;
  display: inline-flex;
  flex-direction: row-reverse;
  width: 100%;

  &.spacing-s {
    gap: var(--cxy-spacing-xxxsm);
  }

  &.spacing-m {
    gap: var(--cxy-spacing-xxsm);
  }

  .percentage {
    @include cxy.font-size('text-s', var(--cxy-fontWeight-bold));
    line-height: 11px;
    color: var(--cxy-color-text-default-body);
  }
}

.label {
  color: var(--cxy-color-text-default-body);
  @include cxy.font-size('text-xs');
}

.indicatorWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 10px;
  container-type: inline-size;

  &.hasMaxWidth {
    max-width: 60px;
  }
}

.indicator {
  width: 100%;
  height: 8px;
  border-radius: 2px;
  order: 2;
}

.success {
  background-color: var(--cxy-color-success);
}

.failure {
  background-color: var(--cxy-color-container-danger);
}

.neutral {
  background-color: var(--cxy-color-surface-primary-default-subtle-hover-atl);
}

.dateTop,
.dateBottom {
  @include cxy.font-size('text-xxs');
  color: var(--cxy-color-text-default-body);
  display: none;
}

.dateTop {
  order: 1;
}

.dateBottom {
  order: 4;
}

.teamName {
  @include cxy.font-size('text-xxs', var(--cxy-fontWeight-medium));
  color: var(--cxy-color-text-default-body);
  text-align: center;
  padding-inline-end: var(--cxy-spacing-xxxsm);
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  order: 3;
}

@supports (container-type: inline-size) {
  .indicatorWrapper {
    container-type: inline-size;
  }

  @container (min-width: 30px) and (max-width: 54px) {
    .dateTop {
      display: block;
    }
    .dateBottom {
      display: none;
    }
  }

  @container (min-width: 50px) {
    .teamName {
      padding-inline-end: 0;
      padding-block-start: var(--cxy-spacing-xxxsm);
      font-size: var(--cxy-fontSize-xs);
      margin-top: 1px;
      writing-mode: horizontal-tb;
      transform: rotate(0);
    }
    .dateTop {
      display: none;
    }
    .dateBottom {
      display: block;
    }
  }

  @container (min-width: 40px) {
    .teamName {
      font-size: var(--cxy-fontSize-xxs);
      padding-inline-end: 0;
      padding-block-start: var(--cxy-spacing-xxxsm);
      margin-top: 1px;
      writing-mode: horizontal-tb;
      transform: rotate(0);
    }
    .dateTop {
      display: none;
    }
    .dateBottom {
      display: block;
    }
  }

  @container (max-width: 29px) {
    .dateTop,
    .dateBottom {
      display: none;
    }
  }
}
